import { useMemo } from "react";
import { useUsersMap } from "@tellescope/tanstack-query";
import { formatName } from "@tellescope/utils";
import { useTranslation } from "react-i18next";
import { BadgeListCell } from "./BadgeListCell";

export interface CareTeamFieldCellProps {
  assignedTo: string[];
}

export const CareTeamFieldCell = ({ assignedTo }: CareTeamFieldCellProps) => {
  const { t } = useTranslation("contacts");
  const usersById = useUsersMap();

  const items = useMemo(
    () =>
      assignedTo.map((userId) => {
        const user = usersById[userId];
        return {
          key: userId,
          label: user ? formatName(user) || user.email || t("Unknown user") : t("Unknown user"),
        };
      }),
    [assignedTo, usersById, t]
  );

  return <BadgeListCell items={items} emptyLabel={t("Unassigned")} />;
};
